<template>
	<div class="message-bubble" v-if="messages.length > 0">
		<div v-for="(msg, key) in messages" :key="key">
			<div v-if="msg.type == 'text'">
				{{ msg.text }}
			</div>
			<div v-if="msg.attachment != null && msg.attachment.type == 'image'">
				<img :src="msg.attachment.url.url" alt="" class="bot-initial-image" />
			</div>
			<div v-if="msg.type == 'actions'" class="bot-start-action button-rounding">
					<v-btn v-for="(action, index) in msg.actions" :key="index" @click="show_catalogue('buy')" class="bot-btn-action button-rounding full-width">
						{{ catalogueText }}
					</v-btn>
				<v-btn @click="show_faqs" class="bot-btn-action button-rounding">
					ayuda
				</v-btn>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data: () => ({
		messages: [],
	}),
	computed: {
		catalogueText() {
			return this.$store.getters["chatStore/get_store_data"].catalogue_name
		}
	},
	created() {
		let fd = new FormData();
		fd.append("message", "init");
		fd.append("driver", "web");
		const data = {
			id: this.$route.params.id,
			data: fd,
		};
		this.$store
			.dispatch("chatStore/inital_bot_message", data)
			.then((response) => {
				this.messages = response.messages;
				// this.show_catalogue('buy')
			});
	},
	methods: {
		show_catalogue(value) {
			let fd = new FormData();
			fd.append("message", value);
			fd.append("driver", "web");
			const data = {
				id: this.$route.params.id,
				data: fd,
			};
			this.$store.dispatch("chatStore/show_catalogue", data);
		},
		show_faqs() {
			let fd = new FormData();
			fd.append("message", "faqs");
			fd.append("driver", "web");
			const data = {
				id: this.$route.params.id,
				data: fd,
			};
			this.$store.dispatch("chatStore/get_faqs", data);
		},
		showCart() {
			this.$store.dispatch("chatStore/setStatusToShowCart");
		},
	},
};
</script>

<style>
.bot-start-action {
	display: flex;
}
.bot-btn-action {
	margin: 10px 10px 10px 0;
}
.bot-initial-image {
	margin: 0 auto;
	width: auto;
	height: auto;
	max-width: 100%;
	max-height: 360px;
	display: block;
	border-radius: 30px 30px 30px 30px;
}
.full-width {
	flex-grow: 1;
}
</style>
